export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
            投稿 · 咨询 · 合作
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            如果你对97视频、丝瓜视频、蓝莓视频、91在线视频等平台有独到见解，或希望我们收录新的在线视频平台，欢迎通过以下方式与我们取得联系。我们重视每一位用户的反馈，期待与你一起完善在线影视平台的综合对比导航。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:contact@example.com"
              className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-mail-line"></i>
              投稿与咨询
            </a>
            <a
              href="#faq"
              className="w-full sm:w-auto px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-question-line"></i>
              查看常见问答
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}